import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from '@/lib/queryClient'
import { ProviderAuthProvider } from '@/hooks/auth'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { ProtectedRoute } from '@/components/layout/ProtectedRoute'
import { AppShell } from '@/components/layout/AppShell'
import { Toaster } from '@/components/ui/sonner'
import LoginPage from '@/pages/LoginPage'
import RegisterPage from '@/pages/RegisterPage'
import OnboardingWizardPage from '@/pages/OnboardingWizardPage'
import VisitQueuePage from '@/pages/VisitQueuePage'
import CaseReviewPage from '@/pages/CaseReviewPage'
import PatientSearchPage from '@/pages/PatientSearchPage'
import PatientRecordPage from '@/pages/PatientRecordPage'
import ProviderProfilePage from '@/pages/ProviderProfilePage'
import PracticeProfilePage from '@/pages/PracticeProfilePage'
import VisitTypeManagementPage from '@/pages/VisitTypeManagementPage'
import AvailabilityPage from '@/pages/AvailabilityPage'
import PaymentsSettingsPage from '@/pages/PaymentsSettingsPage'

export default function App() {
  return (
    <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <ProviderAuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route
              path="/onboarding"
              element={
                <ProtectedRoute>
                  <OnboardingWizardPage />
                </ProtectedRoute>
              }
            />
            <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
              <Route path="/visits" element={<VisitQueuePage />} />
              <Route path="/visits/case/:visitId" element={<CaseReviewPage />} />
              <Route path="/patients" element={<PatientSearchPage />} />
              <Route path="/patients/:patientId" element={<PatientRecordPage />} />
              <Route path="/settings/provider-profile" element={<ProviderProfilePage />} />
              <Route path="/settings/practice" element={<PracticeProfilePage />} />
              <Route path="/settings/visit-types" element={<VisitTypeManagementPage />} />
              <Route path="/settings/availability" element={<AvailabilityPage />} />
              <Route path="/settings/payments" element={<PaymentsSettingsPage />} />
            </Route>
            <Route path="/" element={<Navigate to="/visits" replace />} />
            <Route path="*" element={<Navigate to="/visits" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </ProviderAuthProvider>
    </QueryClientProvider>
    </ErrorBoundary>
  )
}
